import Icon from 'veui/components/Icon'
import { IconCheck } from 'dls-icons-vue'

Icon.register('check', IconCheck)
